/* @license @google-recaptcha/core v1.0.5 */
var e=function(){var e=document.querySelector(".grecaptcha-badge");e&&e.parentNode&&document.body.removeChild(e.parentNode)};export{e as removeGoogleReCaptchaBadge};
//# sourceMappingURL=removeGoogleReCaptchaBadge.js.map
